import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/FishingVesselPrefixType/GetAllForDropdown";

        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "FISHING_VESSEL_PREFIX_RETRIEVED",
                        fishingVesselPrefixes: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
